import { Box } from '@zillow/constellation-10';
import { useMemo } from 'react';
import AttachmentCard from '../AttachmentCard';
import type { Attachment } from '../../../types/attachment';
import ExpiredAttachmentsText from '../ExpiredAttachmentsText';

type Props = {
  isMessageOwner: boolean;
  nonImageAttachments: Array<Attachment>;
  onBeforeAction?: (proceed: () => void) => void;
  onExpiredDetailsClick: () => void;
  onEventTracking: () => void;
  onLogError: () => void;
  downloadEventId?: string;
};

export default function MessageDocumentList({
  isMessageOwner,
  nonImageAttachments,
  onBeforeAction,
  onExpiredDetailsClick,
  onEventTracking,
  onLogError,
  downloadEventId = '',
}: Props): JSX.Element {
  const showExpiredText = useMemo(() => {
    return nonImageAttachments.some((attachment) => attachment.isAttachmentExpired);
  }, [nonImageAttachments]);

  return (
    <>
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: isMessageOwner ? 'flex-end' : 'flex-start' }}>
        {nonImageAttachments.map((nonImageAttachment) => {
          const { fileName, fileSizeBytes, zDocId } = nonImageAttachment;
          const key = zDocId || `${fileName}-${fileSizeBytes}`;

          return (
            // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 270px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
            <Box key={key} data-eventid={downloadEventId} css={{ maxWidth: '270px' }}>
              <AttachmentCard
                attachment={nonImageAttachment}
                variant="message"
                isMessageOwner={isMessageOwner}
                showDateAdded={false}
                downloadEventId={downloadEventId}
                onBeforeAction={onBeforeAction}
                onEventTracking={onEventTracking}
                onLogError={onLogError}
              />
            </Box>
          );
        })}
      </Box>

      {showExpiredText && (
        <ExpiredAttachmentsText
          isPlural={nonImageAttachments.length > 1}
          onExpiredDetailsClick={onExpiredDetailsClick}
        />
      )}
    </>
  );
}
